import React, { useEffect, useState } from 'react';
import DaisyTable from '../../Common/DaisyTable/DaisyTable';
import useFetchData from '../../../hooks/useFetchData';
import { isArray } from 'lodash';
import { filterFns } from '@tanstack/react-table';
import sortingUtils from '../../../utils/sorting.utils';

import CustomersRowActions from './RowActions/CustomersRowActions';
import TableLayout from '../../Common/DaisyTable/TableLayout';
import { TableProvider } from '../../../context/TableContext';
import CustomersHeaderActions from './HeaderActions/CustomersHeaderActions';
import { formatDate } from '../../../utils/format.utils';
import { usePopup } from '../../../context/PopupContext';
import { formatEntityPhone } from '../../../utils/phoneDisplay.utils';

const CustomersTable = () => {

  // Les popups sont maintenant gérés automatiquement par le hook useRouteChange

  const usersDef = [
   

    {
      id: 'firstname',
      accessorFn: row => row.firstname,
      header: () => <span>Prénom</span>,
      cell: info => <span>{info.getValue()}</span>,
      footer: props => props.column.id,
      sortingFn: sortingUtils.sortText,
      enableHiding: true
    },
    {
      id: 'lastname',
      accessorFn: row => row.lastname,
      header: () => <span>Nom</span>,
      cell: info => <span>{info.getValue()}</span>,
      footer: props => props.column.id,
      sortingFn: sortingUtils.sortText,
      enableHiding: true
    },
    {
      id: 'email',
      accessorFn: row => row.email,
      header: () => <span>Email</span>,
      cell: info => info.getValue(),
      footer: props => props.column.id,
      sortingFn: sortingUtils.sortText,
    },
    {
      id: 'phone',
      accessorFn: row => formatEntityPhone(row),
      header: () => <span>Téléphone</span>,
      cell: info => info.getValue(),
      footer: props => props.column.id,
      sortingFn: sortingUtils.sortText,
    },
    {
      id: 'modifiedDate',
      accessorFn: row => new Date(row.modifiedDate),
      header: () => <span>Modifié le</span>,
      cell: info => <span>{formatDate(info.getValue())}</span>,
      footer: props => props.column.id,
      sortingFn: sortingUtils.sortDate,
      enableHiding: true,
      size: 0 // No size needed as it's invisible
    },
    {
      id: 'info',
      header: () => <span></span>,
      cell: info => <CustomersRowActions table={info.table} row={info.row} />,
      footer: props => props.column.id,
      enableGlobalFilter: false,
      enableSorting: false, // disable sorting for this column
      size: 25
    },
  ]

  return (
    <div className='w-full max-w-screen-xl m-auto flex flex-col gap-4'>
      <h1 className='text-5xl text-center'>Mes clients</h1>
      <TableProvider API_URL={'/customers'} CLIENT_CONTENT_URL={'/clients'}>
        <TableLayout headers={usersDef} withCheckbox width={'100%'}>
          <CustomersHeaderActions />
        </TableLayout>
      </TableProvider>
    </div>
  );
};

export default CustomersTable;
